import { cn } from '@/lib/utils'
import type { SVGProps } from 'react'
export const ValkeyLogo = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 73"
    className={cn('dark:brightness-[1.5]', className)}
    {...props}
  >
    <g>
      <path
        fill="#123678"
        fillRule="evenodd"
        stroke="none"
        d="M13.482 60.695L.998 52.885V19.502L31.528 2l29.79 17.531v35.113L31.055 71.689l-10.507-6.573V49.12l-5.696-3.564V27.453l16.494-9.456 16.118 9.485v18.97l-12.76 7.186v-7.64c3.825-1.472 6.57-5.259 6.57-9.728 0-5.76-4.561-10.386-10.116-10.386S21.042 30.511 21.042 36.27c0 4.47 2.745 8.256 6.57 9.729v14.475l3.65 2.282 22.373-12.601v-26.23l-22.158-13.04L8.681 23.954v24.675l4.801 3.004v9.062zm17.676-29.197c2.514 0 4.502 2.166 4.502 4.772 0 2.607-1.988 4.773-4.502 4.773s-4.502-2.166-4.502-4.773c0-2.606 1.988-4.772 4.502-4.772z"
      ></path>
    </g>
  </svg>
)
